var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-friend-product-config"},[_c('ConfigTable',{ref:"ct",attrs:{"searchConfig":_vm.searchConfig,"tableColumns":_vm.tableColumns,"tableData":_vm.list,"total":_vm.total},on:{"change":_vm.loadData,"edit":_vm.edit,"add":_vm.add,"delete":_vm.deleteRow}}),_c('EditProductConfig',{ref:"editDialog",on:{"sure":_vm.callEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }